import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight, MapPin } from "lucide-react";
import { Locale } from "@/i18n";
import { localePath } from "@/lib/nav";
const showroomImg = "https://media.lacontessina.com/site/src/assets/showroom/showroom-main.jpg";
export default function ShowroomTeaser() {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language as Locale) || "it";

  return (
    <section className="py-24 lg:py-36 bg-[hsl(var(--surface))]">
      <div className="lc-container-ext grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <span className="lc-eyebrow">{t("home.showroom.kicker")}</span>
          <h2 className="mt-6 font-display font-light tracking-[-0.035em] leading-[1.02] text-foreground text-[40px] md:text-[56px] lg:text-[68px]">
            {t("home.showroom.title_1")}
            <span className="block italic font-serif font-normal">
              {t("home.showroom.title_2")}
            </span>
          </h2>
          <p className="mt-8 text-[15px] leading-[28px] text-foreground/65 max-w-[480px]">
            {t("home.showroom.description")}
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-[13px] tracking-[0.18em] uppercase text-foreground/60">
            <MapPin className="h-4 w-4" />
            {t("home.showroom.address")}
          </div>
          <div className="mt-10">
            <Link to={localePath(locale, "showroom")} className="lc-btn-solid">
              {t("home.showroom.cta")}
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative overflow-hidden rounded-[28px] aspect-[4/3] bg-background">
            <img
              src={showroomImg}
              alt={t("home.showroom.title_1") + " " + t("home.showroom.title_2")}
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}